import dynamic from "next/dynamic";

import { styled, $error } from "@acko-tech/building-blocks.ui.common";

interface StyleProps {
  error?: boolean;
}
const ChevronDown = dynamic<any>(import("@public/images/chevron-down.svg"), {
  ssr: true
});

const StyledChevronDown = styled(ChevronDown)<StyleProps>`
  & path {
    stroke: ${(props: any) => (props.error === "true" ? $error : ``)};
  }
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 22px;
`;

export default StyledChevronDown;
